// extracted by mini-css-extract-plugin
export var bandeauAlertContainer = "bandeau-alert-module--bandeau-alert-container--c60b0";
export var bandeauAlertTitle = "bandeau-alert-module--bandeau-alert-title--bdde9";
export var sectionAlert = "bandeau-alert-module--section-alert--f3562";
export var sectionAlertButton = "bandeau-alert-module--section-alert-button--122b5";
export var sectionAlertContent = "bandeau-alert-module--section-alert-content--f9fea";
export var sectionAlertHeader = "bandeau-alert-module--section-alert-header--7244d";
export var sectionAlertModal = "bandeau-alert-module--section-alert-modal--93311";
export var sectionAlertTitle = "bandeau-alert-module--section-alert-title--05556";